import { DetailedHTMLProps, HTMLAttributes } from "react";

import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { CapacityEnum } from "~/types/event/eventEnums.type";
import { FullFilterType } from "~/types/filter/filter.types";
import { LocationEnum } from "~/types/location/locationEnums.types";
import { TagType } from "~/types/tag/tag.types";
import { capacities, capacityToNames } from "~/utils/constants/capacity";
import {
  locations,
  locationToColors,
  locationToNames,
} from "~/utils/constants/locations";

import MainButton from "../../common/mainButton";
import Filter from "../filter";
import TagFilter from "../tagFilter";
import styles from "./index.module.scss";

type Props = DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  fullFilter: FullFilterType;
  useCapacityFilter?: boolean;
  handleResetFilter: () => void;
  handleSetLocationFilter: (input: LocationEnum) => void;
  handleSetCapacityFilter: (input: CapacityEnum) => void;
  handleSetTagFilter: (input: TagType) => void;
  relative?: boolean;
  tags: TagType[];
};

const FullFilter = ({
  fullFilter,
  useCapacityFilter,
  handleResetFilter,
  handleSetLocationFilter,
  handleSetCapacityFilter,
  handleSetTagFilter,
  relative = true,
  tags,
}: Props) => {
  const { language } = useLanguage();
  const accountTexts =
    language === "En"
      ? englishTranslations.accountPage
      : frenchTranslations.accountPage;

  const displayAll =
    !fullFilter.locations.length &&
    !fullFilter.capacities.length &&
    !fullFilter.tags.length &&
    !fullFilter.dates;
  return (
    <div className={relative ? styles.relativeFilter : styles.genericFilter}>
      <MainButton
        className={[styles.item, displayAll ? styles.selected : null].join(" ")}
        onClick={handleResetFilter}
      >
        {accountTexts.all}
      </MainButton>
      <>&nbsp;&nbsp;&nbsp;</>
      {accountTexts.locations}
      <Filter<LocationEnum>
        items={locations}
        itemsColor={locations.map((location) => locationToColors[location])}
        filteredItems={fullFilter.locations}
        handleSetFilter={handleSetLocationFilter}
        className={styles.filter}
        mapToName={(item) => locationToNames[item]}
      />
      {useCapacityFilter && (
        <>
          Participants
          <Filter<CapacityEnum>
            items={capacities}
            filteredItems={fullFilter.capacities}
            handleSetFilter={handleSetCapacityFilter}
            className={styles.filter}
            mapToName={(item) => capacityToNames[item]}
          />
        </>
      )}
      {tags.length > 0 && (
        <>
          Tags
          <TagFilter
            tags={tags}
            filter={fullFilter.tags}
            handleSetFilter={handleSetTagFilter}
            className={styles.filter}
          />
        </>
      )}
    </div>
  );
};

export default FullFilter;
